import { render, staticRenderFns } from "./_accOrderId.vue?vue&type=template&id=62b60ea7"
import script from "./_accOrderId.vue?vue&type=script&lang=js"
export * from "./_accOrderId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports